import { type User } from './types';

/**
 * Whether a user counts as verified — port of the web
 * clients/utils/userVerification.ts. Verification is decided exclusively by the
 * `verified` boolean flag.
 */
export function isUserVerified(user: User | null | undefined): boolean {
  if (!user) return false;
  return user.verified === true;
}
